(function () {
  'use strict';

  angular.module('sempraWebapp').factory('PointTypeEnum', pointTypeEnumFactory);

  function pointTypeEnumFactory () {
    return Object.freeze({
      WASH_BOX: 'WASH_BOX',
      VACUUM: 'VACUUM',
      WASH_FACILITY: 'WASH_FACILITY',
      SUBSYSTEM: 'SUBSYSTEM',
      KARCHER_WASH_BOX: "G",
      KARCHER_VACUUM: "U",
      properties: {
        NAMES: {
          TAP_WATER: 'Subsystem6',
          DEMI_WATER: 'Subsystem8',
          REVERSE_OSMOSIS: 'Subsystem9',
          SOFTENED_WATER: 'Subsystem7',
          DOSER: 'Subsystem11'
        }
      }
    });
  }
})();
